/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './article.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/translations/translate.directive';
import * as i3 from '../../../../../app/shared/translations/translations.service';
import * as i4 from '../../../../../app/shared/settings.service';
import * as i5 from '@angular/router';
import * as i6 from '@angular/common';
import * as i7 from '../article-feedback/article-feedback.component.ngfactory';
import * as i8 from '../../../../../app/help-center/shared/article-feedback/article-feedback.component';
import * as i9 from '../../../../../app/help-center/shared/help-center.service';
import * as i10 from '../../../../../app/help-center/shared/article/article.component';
import * as i11 from '@angular/platform-browser';
const styles_ArticleComponent:any[] = [i0.styles];
export const RenderType_ArticleComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_ArticleComponent,data:{}});
function View_ArticleComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),21,'section',[['class',
      'article-container'],['id','article']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),1,'h1',[['class','article-title']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
      ['',''])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),0,'div',[['class','article-body']],[[8,'innerHTML',1]],(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),10,'div',[['class','submit-ticket-container container']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),2,'span',[['trans','']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(4341760,(null as any),0,i2.TranslateDirective,
          [i1.ElementRef,i3.Translations,i4.SettingsService],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['Have more questions?'])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'a',[['routerLink',
          '/help-center/tickets/new'],['trans','']],[[1,'target',0],[8,'href',4]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,15).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(4341760,(null as any),0,i2.TranslateDirective,
          [i1.ElementRef,i3.Translations,i4.SettingsService],(null as any),(null as any)),
      i1.ɵdid(671744,(null as any),0,i5.RouterLinkWithHref,[i5.Router,i5.ActivatedRoute,
          i6.LocationStrategy],{routerLink:[0,'routerLink']},(null as any)),(_l()(),
          i1.ɵted((null as any),['Submit a Request'])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),1,'article-feedback',([] as any[]),(null as any),
          (null as any),(null as any),i7.View_ArticleFeedbackComponent_0,i7.RenderType_ArticleFeedbackComponent)),
      i1.ɵdid(49152,(null as any),0,i8.ArticleFeedbackComponent,[i9.HelpCenterService],
          {articleId:[0,'articleId']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_4:any = '/help-center/tickets/new';
    _ck(_v,15,0,currVal_4);
    const currVal_5:any = _co.article.id;
    _ck(_v,20,0,currVal_5);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.article.title;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _co.trustedArticleBody;
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = i1.ɵnov(_v,15).target;
    const currVal_3:any = i1.ɵnov(_v,15).href;
    _ck(_v,13,0,currVal_2,currVal_3);
  });
}
export function View_ArticleComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_ArticleComponent_1)),i1.ɵdid(16384,(null as any),0,i6.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i10.ArticleComponent = _v.component;
    const currVal_0:any = _co.article;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_ArticleComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'article',([] as any[]),
      (null as any),(null as any),(null as any),View_ArticleComponent_0,RenderType_ArticleComponent)),
      i1.ɵdid(4308992,(null as any),0,i10.ArticleComponent,[i11.DomSanitizer,i5.ActivatedRoute,
          i5.Router,i9.HelpCenterService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ArticleComponentNgFactory:i1.ComponentFactory<i10.ArticleComponent> = i1.ɵccf('article',
    i10.ArticleComponent,View_ArticleComponent_Host_0,{article:'article'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/help-center/shared/article/article.component.ngfactory.ts